module.exports = __webpack_public_path__ + "static/media/high.311e8086.svg";